// Runtime exploit funnel drill-down: the dashboard links to the Findings list with
// `funnel_type=<stage key>`, and the list turns that into its initial filters. Stages are cumulative,
// so a stage applies its own filter plus every earlier one's. Only Findings takes these links: it reads
// /vulnerabilities/list, the findings the funnel counts, while the CVEs list (cves-list) cannot filter
// on in_use, is_public_exposed or epss_severe.
//
// `internet_traffic` maps to `is_public_exposed`, the same field the funnel counts it from.
//
// With no runtime sensor on the selected clusters (`in_use_enabled: false`) the funnel counts its stages
// without the in-use condition, so the link carries `funnel_in_use_enabled=false` and in_use is left out.
const STAGE_FILTERS = [
  { key: 'in_use', filter: 'in_use', value: true },
  { key: 'internet_traffic', filter: 'is_public_exposed', value: true },
  { key: 'exploitable', filter: 'exploitable', value: true },
  { key: 'fixable', filter: 'fixable', value: true },
  { key: 'critical', filter: 'severity', value: 'critical' },
  { key: 'epss_severe', filter: 'epss_severe', value: true },
];

const IN_USE_ENABLED_PARAM = 'funnel_in_use_enabled';

export const DRILLABLE_FUNNEL_STAGES = new Set(STAGE_FILTERS.map(stage => stage.key));

// The drill-down link's params for a stage, given the funnel's `in_use_enabled`.
export const funnelStageParams = (funnelType, inUseEnabled) => ({
  funnel_type: funnelType,
  ...(inUseEnabled === false && { [IN_USE_ENABLED_PARAM]: 'false' }),
});

// The list's initial filters from the drill-down link's query params.
export const funnelStageFilters = query => {
  const stageIndex = STAGE_FILTERS.findIndex(stage => stage.key === query.get('funnel_type'));
  const inUseEnabled = query.get(IN_USE_ENABLED_PARAM) !== 'false';
  return Object.fromEntries(
    STAGE_FILTERS.map((stage, index) => {
      const applies = stageIndex !== -1 && index <= stageIndex && (inUseEnabled || stage.filter !== 'in_use');
      return [stage.filter, applies ? [stage.value] : []];
    }),
  );
};
